module.exports = __webpack_public_path__ + "img/inter-v3-latin-ext_latin-900.2f90849.svg";